// /**
//  * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
//  * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
//  * States and/or other countries.
//  */
import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TextField } from '@material-ui/core';
import { result } from 'lodash';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';

import {
  getOustandingDisputesQuarter,
  getMfgOutstandingDisputesForQuarterExportAll,
  setMfgOutstandingDisputesForQuarterExportAll,
  setPaginationIndex,
} from '../Store/actions';
import { QuarterDisplay } from './TableHead';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import PaginationBox from './PaginationBox';
import { exportAllPDF } from '../../../../SharedModules/pdfExport/exportAll';

const DisplayOutstandingDisputesForQuarter = () => {
  const dispatch = useDispatch();
  const {
    outstandingDisputesQuarter,
    outstandingDisputesQuarterHeader,
    rebateProgramName,
    rebateProgramList,
    allRebateProgram,
    isLoading,
    manufacturerSelected,
    rebateProgramValue,
    quarterValue,
    exportAllData,
    rebateProgrameName,
    searchScreenVar: { countValue },
  } = useSelector(
    (state) => state?.sharedState?.OutstandingDisputesForQuarterReducer
  );
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const [resultList, setResultList] = React.useState([]);
  const [resultHeader, setResultHeader] = React.useState([]);
  const [fullScreenView, setfullScreenView] = React.useState(false);
  const [count, setCount] = React.useState(countValue);
  const paginationArray = [...Array(resultHeader?.length).keys()];
  const [exportAllClicked, setExportAllClicked] = useState(false);
  const [columnApi, setColumnApi] = React.useState(null);

  const handleFullScreenView = () => {
    setfullScreenView(!fullScreenView);
  };
  const [filteredRows, setFilteredRow] = React.useState([]);

  useEffect(() => {
    setCount(countValue || 1);
  }, [countValue]);

  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );

  // TO get the complete name of the rebate program
  const rebateProgramNameValue = rebateProgrameName;

  // To pin the total row
  const [filterApply, setFilterApply] = React.useState(false);
  const getFilterApply = (filterApplied) => {
    setFilterApply(filterApplied);
  };

  //   //Function to add the rows
  const sum = (property) => {
    const displayedRows = filterApply ? filteredRows : resultList;
    // const displayedRows = resultList;
    if (property === 'checkLogNum') {
      const data = displayedRows.length;
      return `${data} Checks`;
    }
    const data = displayedRows?.reduce((accumulator, object) => {
      return (
        accumulator + (object[property] ? parseFloat(object[property]) : null)
      );
    }, 0);

    return data
      ? parseFloat(data)
      : // ? parseFloat(data).toLocaleString('en-US', { minimumFractionDigits: 2 })
        0;
  };
  const onGridReady = (params) => {
    setColumnApi(params.columnApi);
  };
  //   //columns to show total
  const createData = (count, prefix) => {
    const result = [];
    for (let i = 0; i < count; i += 1) {
      result.push({
        isBottomRow: true,
        totalDisputedDollars: sum('totalDisputedDollars').toFixed(2),
        totalDisputedUnits: parseFloat(sum('totalDisputedUnits')).toFixed(4),
        totalNdc: sum('totalNdc'),
        mfgId: 'Grand Total',
      });
    }
    return result;
  };

  // To pin the total row
  const pinnedBottomRowData = useMemo(() => {
    return createData(1, 'Bottom');
  }, [resultList, filteredRows, filterApply]);

  const onFilterChanged = (rowData, type) => {
    // let updatedRowData = rowData.map((item) => {
    //   return {
    //     ...item,
    //     totalDisputedDollars: parseFloat(
    //       item.totalDisputedDollars.replace('$', '').replace(/,/g, '')
    //     ),
    //   };
    // });
    setFilteredRow(rowData);
  };

  /*
    This function handle the side effect of next previios of pagination box
  */
  const handleClick = (type, value) => {
    if (type === 'next') {
      dispatch(setPaginationIndex(count + 1));
    }

    if (type === 'previous') {
      dispatch(setPaginationIndex(count - 1));
    }

    if (type === 'change') {
      if (value < 1 || value > paginationArray.length) {
        dispatch(setPaginationIndex(paginationArray.length));
      } else {
        dispatch(setPaginationIndex(value));
      }
    }
  };

  // this function handle the vlue like text in input box
  const handleBlur = async (value) => {
    if (
      value < 1 ||
      parseInt(value) > paginationArray.length ||
      value === '' ||
      isNaN(value)
    ) {
      dispatch(setPaginationIndex(0));
      await Promise.resolve();
      // setTimeout(() => {
        value < 1
          ? dispatch(setPaginationIndex(1))
          : dispatch(setPaginationIndex(paginationArray.length));
      // }, 20);
    } else {
      dispatch(setPaginationIndex(parseInt(value)));
    }
  };

  React.useEffect(() => {
    if (outstandingDisputesQuarterHeader) {
      const data = outstandingDisputesQuarterHeader;
      data.sort((a, b) => {
        return a.displaySeq - b.displaySeq;
      });
      setResultHeader(data);
    }
  }, [outstandingDisputesQuarterHeader]);

  //   //API call for Grid
  React.useEffect(() => {
    if (resultHeader.length > 0) {
      dispatch(
        getOustandingDisputesQuarter({
          quarter: quarterValue,
          rebateProgramCd: allRebateProgram
            ? resultHeader[count - 1]?.rebateProgramCd
            : rebateProgramValue,
          mfgId: manufacturerSelected,
          aiAll: manufacturerSelected[0] === 'ALL' ? '1' : '0',
        })
      );
    }
  }, [resultHeader, count]);

  const [exportFileName, setExportFileName] = React.useState(null);
  const exportAllTpPDF = (name) => {
    setExportFileName(name);
    dispatch(setMfgOutstandingDisputesForQuarterExportAll([], 'noData'));
    setExportAllClicked(true);
    dispatch(
      getMfgOutstandingDisputesForQuarterExportAll({
        quarter: quarterValue,
        mfgId: manufacturerSelected,
        aiAll: manufacturerSelected[0] === 'ALL' ? '1' : '0',
        rebatePrograms: resultHeader,
      })
    );
  };

  const addPinnedRowData = () => {
    const exportAllDataObj = {};
    for (const key in exportAllData) {
      const data = JSON.parse(JSON.stringify(exportAllData[key]));
      const pinnedRow = {
        // rebateProgramName: 'ALL - All Rebate Programs',
        // mfgId: '00093',
        mfgName: 'Grand Total :',
        // qtr: '2Q2020',
        totalNdc: 0,
        totalDisputedUnits: 0,
        totalDisputedDollars: 0,
        bold: true,
      };
      for (let i = 0; i < data.length; i++) {
        pinnedRow.totalNdc += data[i].totalNdc;
        pinnedRow.totalDisputedUnits += data[i].totalDisputedUnits;
        pinnedRow.totalDisputedDollars += data[i].totalDisputedDollars;
      }
      // pinnedRow.totalDisputedUnits = pinnedRow.totalDisputedUnits.toFixed(4);
      data.push(pinnedRow);
      exportAllDataObj[key] = data;
    }
    for (const key in exportAllDataObj) {
      exportAllDataObj[key] = exportAllDataObj[key].map((item) => {
        return {
          ...item,
          totalDisputedUnits: item.totalDisputedUnits.toFixed(4),
        };
      });
    }
    return exportAllDataObj;
  };

  React.useEffect(() => {
    if (
      exportAllClicked &&
      Object.keys(exportAllData).length === resultHeader.length &&
      resultHeader.length > 0
    ) {
      const mapping = {};
      for (let i = 0; i < resultHeader.length; i++) {
        mapping[
          resultHeader[i].rebateProgramCd
        ] = `${resultHeader[i].rebateProgramName}`;
      }
      const header = {
        reportName: 'Outstanding Disputes For Quarter',
        fileName: exportFileName,
      };
      const paginationArr = resultHeader.map((item) => item.rebateProgramCd);
      const allData = addPinnedRowData(exportAllData);
      // allData = allData.map((item) => {
      //   return {
      //     ...item,
      //     totalDisputedUnits: item.totalDisputedUnits.toFixed(4),
      //   };
      // });
      const widths = QuarterDisplay.map((item, index) =>
        index === 1 ? 240 : '*'
      );
      // console.log('allData', allData);
      setExportAllClicked(false);
      exportAllPDF(
        header,
        allData,
        columnApi,
        userDefaults,
        {
          // pageSize: {
          //   width: 1250,
          //   height: 700,
          // },
          mapping,
          info: {
            fourthInfo: `Quarter: ${quarterValue}`,
          },
        },
        paginationArr,
        widths,
        logInUser
      );
    }
  }, [exportAllData]);

  React.useEffect(() => {
    const updatedSearchResult =
      outstandingDisputesQuarter?.outStandingDisputesForQuarterDetailsVO || [];
    setResultList(updatedSearchResult);
  }, [outstandingDisputesQuarter]);

  //   //PDF header
  const firstInfo = `Quarter : ${quarterValue}`;
  const thirdInfo = `${resultHeader[count - 1]?.rebateProgramName}`;

  return (
    <div className="tabs-container bottom-pinned-bold">
      <Spinner load={isLoading} />
      {!fullScreenView && (
        <CustomSeparator
          parent1="State Reports"
          parent2="Display Outstanding Disputes For Quarter"
        />
      )}
      {!fullScreenView && (
        <div className="tab-body custom-search-dates">
          {!fullScreenView && (
            <>
              <div className="row mt-4">
                <PaginationBox
                  array={paginationArray}
                  count={count}
                  handleClick={handleClick}
                  handleBlur={handleBlur}
                />
              </div>
              <div className="mui-custom-form input-md field-xl">
                <div className="row mb-4">
                  <div className="col-6">
                    <TextField
                      label="Rebate Program : "
                      id="Rebate Program"
                      fullWidth
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      disabled
                      value={
                        allRebateProgram
                          ? resultHeader[count - 1]?.rebateProgramName
                          : `${rebateProgramNameValue}`
                      }
                    />
                  </div>
                  <div className="col-6">
                    <TextField
                      label="Quarter : "
                      id="Quarter"
                      fullWidth
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      disabled
                      value={quarterValue}
                    />
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      )}

      <TableGridWithFeatures
        rowData={
          resultList.map((item) => {
            return {
              ...item,
              totalDisputedDollars: item.totalDisputedDollars
                ? item.totalDisputedDollars
                : '0.00',
              totalDisputedUnits: item.totalDisputedUnits
                ? item.totalDisputedUnits.toFixed(4)
                : '0.0000',
            };
          }) || []
        }
        columnDefs={QuarterDisplay}
        rowMultiSelectWithClick
        data-testid="onEditingStopped"
        enterMovesDown
        showResetFilter={false}
        defaultCol={{
          wrapHeaderText: true,
          autoHeaderHeight: true,
        }}
        // isScrollOn
        countValue={count}
        hideTotalCount={false}
        exportFile
        fileName="OutstandingDisputesforQuarter"
        reportName="Outstanding Disputes for Quarter Report"
        fullScreenView={fullScreenView}
        handleFullScreenViewClick={handleFullScreenView}
        gridHeight={fullScreenView ? '100vh' : viewPortHeight_355}
        info={{ firstInfo, thirdInfo }}
        pinnedBottomRowData={pinnedBottomRowData}
        onFilterData={onFilterChanged}
        exportAllTpPDF={resultHeader.length > 1 ? exportAllTpPDF : null}
        frameworkComponents={{
          TextBoxRender: (cellInfo) => {
            const name = cellInfo?.value;
            if (name && name.length > 20) {
              return (
                <OverlayTrigger
                  placement="bottom"
                  overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                >
                  <div>{name}</div>
                </OverlayTrigger>
              );
            }
            return <div>{name}</div>;
          },
        }}
        getFilterApply={getFilterApply}
        gridCall={onGridReady}
      />
    </div>
  );
};

export default DisplayOutstandingDisputesForQuarter;
